import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({ name: 'companyDate' })
export class CompanyDatePipe extends DatePipe implements PipeTransform {

    override transform(value: string, region: string, additional?: string): any {
        let fmt = (region == 'en-US' || region == 'en-CA') ? 'MM/dd/yyyy' : 'dd/MM/yyyy';
        if (additional) {
            fmt = additional + " " + fmt;
        }
        return super.transform(value, fmt);
    }
}
